import React, { useCallback, useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, CalendarCheckIcon, PackageCheckIcon } from 'lucide-react';
const guarantees = [{
  icon: ShieldCheckIcon,
  title: '30-Day Risk-Free Trial',
  body: "Test your LumiMate in your own space. Stick it to your monitor, take it to your late-night study sessions, and feel the vibe. If it doesn't spark joy or boost your focus within 30 days, send it back for a full, no-questions-asked refund. Your satisfaction is our only metric."
}, {
  icon: CalendarCheckIcon,
  title: '1-Year Structural Replacement',
  body: "The LumiMate is built for thousands of poses. If the suction cups fail or the limbs lose tension due to manufacturing defects within the first 12 months, we won't just repair it—we'll ship you a brand-new replacement at zero cost to you."
}, {
  icon: PackageCheckIcon,
  title: 'Safe-Arrival Guarantee',
  body: "Shipping can be rough, but we've got your back. If your LumiMate arrives with a scratch or the LED doesn't shine perfectly out of the box, we take full responsibility. We'll send a replacement express, no extra shipping fees required."
}];
export function TrustGuarantees() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const goToNext = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % guarantees.length);
  }, []);
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(goToNext, 3500);
    return () => clearInterval(timer);
  }, [isPaused, goToNext]);
  return <section className="py-12 overflow-hidden" data-id="element-174">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl font-bold text-center text-white mb-10" data-id="element-175">
        Trust & Guarantees
      </motion.h2>

      <div className="relative w-full max-w-sm mx-auto" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onTouchStart={() => setIsPaused(true)} onTouchEnd={() => setIsPaused(false)} data-id="element-176">
        <div className="relative h-[320px]" data-id="element-177">
          <AnimatePresence mode="wait" data-id="element-178">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 80
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -80
          }} transition={{
            duration: 0.35,
            ease: 'easeInOut'
          }} className="absolute inset-0 bg-brand-card border border-white/5 rounded-2xl p-6 flex flex-col items-center text-center" data-id="element-179">
              <div className="p-4 bg-brand-dark rounded-2xl shadow-[0_0_15px_rgba(255,106,0,0.15)] text-brand-orange mb-5" data-id="element-180">
                {createElement(guarantees[currentIndex].icon, {
                className: 'w-8 h-8'
              })}
              </div>
              <h3 className="text-lg font-bold text-white mb-3" data-id="element-181">
                {guarantees[currentIndex].title}
              </h3>
              <p className="text-sm text-brand-muted leading-relaxed" data-id="element-182">
                {guarantees[currentIndex].body}
              </p>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-2 mt-5" data-id="element-183">
          {guarantees.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`h-2 rounded-full transition-all duration-300 ${i === currentIndex ? 'bg-brand-orange w-6' : 'bg-white/20 w-2 hover:bg-white/40'}`} data-id="element-184" />)}
        </div>
      </div>
    </section>;
}